import React from 'react';

export function ScoreButton(props){
    const className = `nps-box color-nps-${props.scorenumber}`;

    return(
        <div className="col-xs-1 col-nps">
            <div className={className}>
                <div className="nps-box-content">
                    <div>
                        <span onClick={()=>{props.handleChange(props.value+1)}}>{props.scorenumber}</span>
                    </div>
                </div>
            </div>
            <div className="value">
                <input type="text" value={props.value || 0} onChange={(event)=>{props.handleChange(parseInt(event.target.value))}} />
            </div>
        </div>
    )
}